import { useRef, useEffect, useState } from "react";

import { AnimatePresence } from "framer-motion";
import useMeasure from "react-use-measure";
import { _project } from "state/store.projects";
import { _isometry } from "state/store.isometry";
import { active_project, currentSeason, kioskMode, seasonMode, weaterMode } from "state/store.global";
import { iso_free } from "state/store.global";
import { iso_isrotating } from "state/store.global";
import { getFocus, setFocus, useGet } from "state/jotai";
import { getIsoData, getSeasonIsoData, setIsoData, setSeasonIsoData } from "state/jotai.isometryDataHooks";
import { getProjectData } from "state/jotai.projectDataHooks";

import { useBreak } from "hooks/useBreak";

import { Space } from "./Isometry.style";
import { Cursor } from "./Isometry.Cursor";
import { createZppSetup } from "./Isometry.ZoomPanPinch";
import { Center } from "./Isometry.Center";
import { Tiny } from "./Isometry.Tiny";
import { Svg } from "./Isometry.Svg";
import { Controls } from "./Isometry.Controls";
import { Measure } from "./Isometry.Measure";
import { Recenter } from "./isometry.Recenter";
import { Loading2 } from "components/Loading2/Loading2";
import { ZoomPanPinch } from "components/ZoomPanPinch/ZoomPanPinch";
import { Compas } from "components/Compas/Compas";
import { ColorLegend } from "components/ColorLegend/ColorLegend";
import { NoSnapSlider } from "components/IsometryControls/NoSnapSlider";
import { SnapOnRotationEnd } from "components/IsometrySnapOnRotationEnd/SnapOnRotationEnd";
import { Status } from "components/StatusPopup/StatusPopup";
import { Mode360 } from "components/IsometryRotation/360";
import { drawer_animation_done } from "state/store.global";
import { _seasons_isometry } from "state/store.season";
import SelectWeather from "components/SunDiagram/SelectWeather";
import { SeasonsNoSnapSlider } from "components/IsometryControls/SeasonsNoSnapSlider";
import { SeasonCanvas } from "./Isometry.SeasonCanvas";
import { SeasonOverviewBack } from "./SeasonOverviewBack";
import { SeasonsPlay } from "components/IsometryRotation/SeasonsPlay";
import styled from "styled-components";
import { BREAK_ } from "constants";
import { _bootstrap } from "state/store.bootstrap";
import { SelectWeatherMobile } from "components/SunDiagram/SeletWeatherMobile";

export const SeasonIsometry = () => {

  const isMobile          = useBreak('md_dn');
  const [measure, bounds] = useMeasure();
  const [frame, setFrame] = useState(1000);
  
  const { pin, pid }        = useGet(active_project);
  const isKisokMode         = useGet(kioskMode);
  const activeIsometryFrame = getIsoData("activeframe");

  const season     = getFocus(_seasons_isometry, 'season_type');
  const seasonType = season?.[pin]?.[pid]?.[activeIsometryFrame]?.type;

  const season_activeIsometryFrame = getSeasonIsoData("activeframe")?.[activeIsometryFrame]?.[seasonType];
  const projectType  = getFocus(_bootstrap, 'type')

  const mode    = true;
  const tiny    = getSeasonIsoData("tiny", "src");
  const frames  = getSeasonIsoData("frames")?.[activeIsometryFrame]?.[seasonType];

  const percent = getSeasonIsoData("percent")?.[activeIsometryFrame]?.[seasonType];
  const status  = getSeasonIsoData("status")?.[activeIsometryFrame]?.[seasonType];
  const config  = getSeasonIsoData("config")?.SEASONS?.[activeIsometryFrame]?.[seasonType]

  const index = getIsoData("snapindex");
  const units = getProjectData("units", "Units");

  const setSeasonFrame = setSeasonIsoData('activeframe')

  const setIndex = setIsoData("snapindex");
  
  const setScale       = setFocus(_seasons_isometry, "activescale");
  const scale       = getFocus(_seasons_isometry, "activescale");
  const setWeatherMode = useGet(weaterMode)

  const zppRef   = useRef();
  const canRef   = useRef();
  const dim      = { W: isKisokMode ? config?.KIOSK_IMAGE_W : config?.IMAGE_W, H: isKisokMode ? config?.KIOSK_IMAGE_H : config?.IMAGE_H };
  const point    = config?.CENTER;
  const zppsetup = createZppSetup(bounds, zppRef, dim, setScale, mode, pin, config);
  const rmode    = useGet(iso_free);
  const isrotate = useGet(iso_isrotating);
 
  const buttonsLabel = getFocus(_project, "buttonsLabel")?.[pin]?.[pid] ?? [];
 

  // if (config && pid && pin >= 0)
    return (
      <>
      <SeasonOverviewBack />
      { isMobile && <SelectWeatherMobile />}
        <Cursor>
          {/* <Space   d   = {25} m = {120} /> */}
          <Measure ref = {measure}>
            <ZoomPanPinch {...{ ref: zppRef, ...zppsetup }}>
              <SeasonCanvas
                {...{ ref: canRef, frame: season_activeIsometryFrame, pid, status, dim, frames, config }}
              />
              <Center {...{ point }} />
            </ZoomPanPinch>
          </Measure>
          {/* <Space d = {180} m = {110} /> */}
          {setWeatherMode === true && !isMobile ? <SelectWeather /> : <></>}
          <Loading2
            {...{
              progress: percent,
              show    : (status !== "DONE" || !units) && frames?.length > 1,
            }}
          />
          <AnimatePresence>

            {rmode && status === "DONE" && Boolean(season_activeIsometryFrame) && (
              <>
                <SeasonsNoSnapSlider
                  {...{ frame: season_activeIsometryFrame, setFrame: setSeasonFrame, config, frames, index, setIndex }}
                />
                {rmode && isrotate && Boolean(season_activeIsometryFrame) && (
                  <SeasonsPlay {...{ frame: season_activeIsometryFrame, setFrame: setSeasonFrame, config, setIndex }} />
                )}
              </>
            )}
          </AnimatePresence>
          
          { percent === "100" &&
              <FloatBtn rmode = {rmode} projectType = {projectType} pin = {pin}>
            { !isMobile && <Recenter canvasScale={scale} config={config} rmode = {rmode} z           = {zppRef} bounds   = {bounds} dim = {dim} pin = {pin}/>}
            <Compas   frame = {frame} cfg         = {config} label    = {buttonsLabel?.filter( btn => btn.UILabelProperty === 'Nordpil')[0]?.Label}  {...{percent}}/>
            </FloatBtn>
            }
            { percent === "100" && isMobile &&
              <RecenterWrapper rmode = {rmode} projectType = {projectType} pin = {pin}>
              <Recenter canvasScale={scale} config={config}  rmode = {rmode} z           = {zppRef} bounds   = {bounds} dim = {dim} pin = {pin}/>
              </RecenterWrapper>
            }
        </Cursor>
      </>
    );
};

const RecenterWrapper = styled.div`
  position: absolute;
  top: 28px; /* Default desktop position */
  right: ${({ rmode }) => (rmode ? 128 : 128)}px;
  ${BREAK_.md_dn} {
    top: unset;
    bottom: 16px;
    right: 16px;
  }
`;

const FloatBtn = styled.div`
  position: absolute;
  top     : 28px;
  right   : ${({rmode}) => rmode ? 42 : 42 }px;
  display : flex;
  gap     : 8px;

    ${BREAK_.md_dn} {
      top: ${({rmode,pin, projectType}) =>(pin > 0 || projectType === 'mono') && rmode ? '17px' :  '86px'};
      right   : 18px;
    }
`